import BaseModelAPI from '../BaseModelAPI';

export default class DeliveryInstructionSubcontractList extends BaseModelAPI {

	static entity = 'deliveryinstructionsubcontractlist'
	static entityName = 'deliveryinstructionsubcontract';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
